function click(context: AudioContext, time: number, accent: boolean, secondary: boolean): void {
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = "sine";
  oscillator.frequency.value = accent ? 1760 : secondary ? 1318 : 988;
  gain.gain.setValueAtTime(0.0001, time);
  gain.gain.exponentialRampToValueAtTime(accent ? 0.2 : 0.08, time + 0.004);
  gain.gain.exponentialRampToValueAtTime(0.0001, time + 0.045);
  oscillator.connect(gain);
  gain.connect(context.destination);
  oscillator.start(time);
  oscillator.stop(time + 0.05);
}

export interface Metronome {
  start: (bpm: number, beats: number, onBeat: (beat: number) => void) => void;
  update: (bpm: number, beats: number) => void;
  stop: () => void;
}

export function createMetronome(): Metronome {
  let context: AudioContext | null = null;
  let timer = 0;
  let next = 0;
  let count = 0;
  let bpm = 96;
  let beats = 4;
  let onBeat: (beat: number) => void = () => undefined;

  const schedule = () => {
    if (!context) return;
    while (next < context.currentTime + 0.16) {
      const place = count % beats;
      click(context, next, place === 0, beats >= 6 && place === Math.floor(beats / 2));
      const shown = place;
      const delay = Math.max(0, (next - context.currentTime) * 1000);
      window.setTimeout(() => onBeat(shown), delay);
      next += 60 / Math.max(20, bpm);
      count += 1;
    }
    timer = window.setTimeout(schedule, 40);
  };

  return {
    start(nextBpm, nextBeats, listener) {
      this.stop();
      bpm = nextBpm;
      beats = Math.max(1, nextBeats);
      onBeat = listener;
      context = new AudioContext();
      void context.resume();
      next = context.currentTime + 0.06;
      count = 0;
      schedule();
    },
    update(nextBpm, nextBeats) {
      bpm = nextBpm;
      beats = Math.max(1, nextBeats);
    },
    stop() {
      window.clearTimeout(timer);
      const current = context;
      context = null;
      void current?.close();
    },
  };
}
